import script from "./home-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./home-page.vue?vue&type=script&setup=true&lang=ts"

import "./home-page.vue?vue&type=style&index=0&id=26565f1b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26565f1b"]])

export default __exports__